import { DepositRegister } from "../models/depositregister";
import { responseHero } from "../utils/axiosInterceptor";

export const getUserDepositsData = (user_id: number, system_id: number): Promise<DepositRegister[]> => {
    return new Promise<DepositRegister[]>((resolve, reject) => {
        if(!user_id) return;

        responseHero.get(`${process.env.REACT_APP_API_URL}/userdeposits/${user_id}/${system_id}`).then((response) => {
            resolve(response.data as DepositRegister[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};